import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { AsyncEntity } from 'src/global';
import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import {
  createDeviceGroupVideoAPI,
  deleteDeviceGroupVideoAPI,
  fetchDeviceGroupVideoAPI,
  getDeviceGroupVideosAPI,
  updateDeviceGroupVideoAPI,
} from 'src/features/deviceGroupVideos/deviceGroupVideos.api';
import { DeviceGroupVideo } from 'src/features/deviceGroupVideos/deviceGroupVideos.types';

const name = 'deviceGroupVideos';

const deviceGroupVideosEntityAdapter = createEntityAdapter<AsyncEntity<DeviceGroupVideo>>({
  selectId: item => item.id,
});

export const deviceGroupVideosSelectors = deviceGroupVideosEntityAdapter.getSelectors();

export const fetchDeviceGroupVideos = createAsyncThunkFromFetch(
  `${name}/fetchDeviceGroupVideos`,
  getDeviceGroupVideosAPI
);
export const createDeviceGroupVideo = createAsyncThunkFromFetch(
  `${name}/createDeviceGroupVideo`,
  createDeviceGroupVideoAPI
);
export const fetchDeviceGroupVideo = createAsyncThunkFromFetch(
  `${name}/fetchDeviceGroupVideo`,
  fetchDeviceGroupVideoAPI
);
export const updateDeviceGroupVideo = createAsyncThunkFromFetch(
  `${name}/updateDeviceGroupVideo`,
  updateDeviceGroupVideoAPI
);
export const deleteDeviceGroupVideo = createAsyncThunkFromFetch(
  `${name}/deleteDeviceGroupVideo`,
  deleteDeviceGroupVideoAPI
);

const packagesSlice = createSlice({
  name,
  initialState: deviceGroupVideosEntityAdapter.getInitialState<{
    isPending: boolean;
    hasError: boolean;
  }>({
    isPending: false,
    hasError: false,
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchDeviceGroupVideos.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchDeviceGroupVideos.fulfilled, (state, { payload }) => {
      deviceGroupVideosEntityAdapter.setAll(state, payload);
      state.isPending = false;
      state.hasError = false;
    });
    builder.addCase(fetchDeviceGroupVideos.rejected, state => {
      state.isPending = false;
      state.hasError = true;
    });
    builder.addCase(deleteDeviceGroupVideo.pending, (state, { meta }) => {
      deviceGroupVideosEntityAdapter.updateOne(state, {
        id: meta.arg.groupId,
        changes: { isPending: true },
      });
    });
    builder.addCase(deleteDeviceGroupVideo.fulfilled, (state, { meta }) => {
      deviceGroupVideosEntityAdapter.removeOne(state, meta.arg.groupId);
    });
    builder.addCase(deleteDeviceGroupVideo.rejected, (state, { meta }) => {
      deviceGroupVideosEntityAdapter.updateOne(state, {
        id: meta.arg.groupId,
        changes: { isPending: false, hasError: true },
      });
    });
    builder.addCase(createDeviceGroupVideo.fulfilled, (state, { payload }) => {
      deviceGroupVideosEntityAdapter.addOne(state, payload);
    });
    builder.addCase(fetchDeviceGroupVideo.fulfilled, (state, { payload }) => {
      deviceGroupVideosEntityAdapter.upsertOne(state, payload);
    });
    builder.addCase(updateDeviceGroupVideo.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(updateDeviceGroupVideo.fulfilled, (state, { payload }) => {
      deviceGroupVideosEntityAdapter.updateOne(state, {
        id: payload.id,
        changes: payload,
      });
      state.isPending = false;
    });
  },
});

const { reducer } = packagesSlice;

export default reducer;
